import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastService } from 'govbr-lib';
import { finalize } from 'rxjs/operators';
import { CadastrarUsuarioDTO } from 'src/app/models/CadastrarUsuarioDTO';
import { Departamento } from 'src/app/models/Departamento';
import { SigaDadosUsuario } from 'src/app/models/Interface/SigaDadosUsuario';
import { UsuarioDTO } from 'src/app/models/UsuarioDTO';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SigaService } from 'src/app/services/siga.service';
import { AutenticacaoService } from '../../login/service/autenticacao.service';
import { UsuarioService } from '../service/usuario.service';
import { Status } from 'src/app/models/Enum/Status';

@Component({
  selector: 'gov-primeiro-acesso',
  templateUrl: './primeiro-acesso.component.html',
  styleUrls: ['./primeiro-acesso.component.scss']
})
export class PrimeiroAcessoComponent implements OnInit {

  usuario: UsuarioDTO = new UsuarioDTO();

  titulo = 'Cadastrar'
  alterar = false;
  mostraForm = false;

  fotoPerfil: string = 'assets/avatar.png';
  isHovering: boolean = false;

  areas: Departamento[] = [];
  areasSelecionadas: Departamento[] = [];
  usuarioFormGroup: FormGroup;

  //Informações vindas do login
  login: string;
  cdCliente: number;
  senha: string;
  cdContato: number;
  carregando: boolean;
  msgRedirecionamento: boolean;

  constructor(private usuarioService: UsuarioService,
    private departamentoService: DepartamentoService,
    private toaster: ToastService,
    private router: Router,
    private sigaService: SigaService,
    private autenticacaoService: AutenticacaoService,
    private analytics: GoogleAnalyticsService
  ) { }

  async ngOnInit(): Promise<void> {

    const dadosLogin = localStorage.getItem('infoUserLogin');
    if (dadosLogin) {
      const { login, cdCliente, senha, cdContato } = JSON.parse(dadosLogin);
      this.login = login;
      this.cdCliente = cdCliente;
      this.senha = senha;
      this.cdContato = cdContato;

      localStorage.removeItem('infoUserLogin');
    }

    this.usuario = await this.buscarDadosUsuario();
    this.alterar = true;
    this.titulo = 'Cadastrar';
    this.buscarAreasBack();

    const departamentoExistente = this.areasSelecionadas.some(area => area.id === this.usuario.departamento.id);

    if (!departamentoExistente) {
      this.areasSelecionadas.push(this.usuario.departamento);
    }
  }


  async buscarDadosUsuario(): Promise<UsuarioDTO> {
    try {
      const user: UsuarioDTO = new UsuarioDTO();

      const response: SigaDadosUsuario = await this.sigaService.getDadosUsuario(this.cdContato, this.cdCliente, this.login, this.senha).toPromise();

      user.cdCliente = this.cdCliente;
      user.nomeCliente = response.nmCliente;
      user.nome = response.nmContato;
      user.email = response.email;
      user.telefone = response.telefone;
      user.celular = response.celular;
      user.login = this.login;
      user.ativo = response.ativo === 'Y' ? Status.Sim : Status.Não;

      const cdDepartamento = response.cdDepartamento;
      const departamento = await this.departamentoService.buscarDepartamentoPorCdDepartamento(cdDepartamento).toPromise();
      user.departamento = departamento;
      user.departamentoId = departamento.id;

      return user;
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
      this.toaster.show({ type: 'danger', text: 'Erro ao buscar dados do usuário.' });
    }
  }

  buscarAreasBack() {
    this.departamentoService.listarDepartamentosAtivos().subscribe(departamentos => {
      this.areas = departamentos;
    });
  }

  salvarUsuario(usuarioAtualizado: UsuarioDTO) {
    this.carregando = true;

    if (!usuarioAtualizado) {
      this.toaster.show({ type: 'danger', text: 'Usuário não encontrado!' });
      return;
    }

    let usuarioDtoBack: CadastrarUsuarioDTO;
    try {
      usuarioDtoBack = this.convertToCadastrarUsuarioDTO(usuarioAtualizado);
    } catch (error) {
      this.toaster.show({ type: 'danger', text: 'Erro ao processar dados do usuário!' });
      return;
    }

    this.usuarioService.cadastrarUsuarioBack(usuarioDtoBack, usuarioDtoBack.login, this.senha, usuarioDtoBack.cdCliente).subscribe(
      (response: UsuarioDTO) => {
        const usuarioId = response.id;
        localStorage.setItem('usuarioId', usuarioId.toString());
        this.autenticarUsuarioCadastro();

        this.analytics.emitirEvento('U1_primeiro_acesso', 'access', 'cadastro_novo_usuario');
      },
      (error) => {
        this.carregando = false;
        if (error.error.status == 400) {
          // Iterando sobre todas as prorpriedades do objeto
          for (const chave in error.error.errors) {
            this.toaster.show({ type: 'danger', text: error.error.errors[chave][0] });
            return;
          }
        }
        this.toaster.show({ type: 'danger', text: error.error.detail });
      }
    );
  }

  convertToCadastrarUsuarioDTO(usuario: UsuarioDTO): CadastrarUsuarioDTO {
    let areasInteresseArray: number[] = [];

    if (usuario.areasInteresse && Array.isArray(usuario.areasInteresse)) {
      usuario.areasInteresse.forEach((area: any) => {
        areasInteresseArray.push(area);
      });
    }

    return {
      nome: usuario.nome,
      email: usuario.email,
      login: usuario.login,
      ativo: usuario.ativo,
      departamentoId: this.usuario.departamento.id,
      fotoPerfil: usuario.fotoPerfil,
      senha: usuario.senha,
      telefone: usuario.telefone,
      celular: usuario.celular,
      areasInteresseId: areasInteresseArray,
      cdContato: this.cdContato,
      nomeCliente: usuario.nomeCliente,
      cdCliente: this.usuario.cdCliente,
      consentimento: usuario.consentimento.consentimento,
    };
  }

  autenticarUsuarioCadastro() {
    this.msgRedirecionamento = true;

    const login = {
      cdCliente: String(this.cdCliente),
      login: this.login,
      senha: this.senha
    }
    this.autenticacaoService.autenticacao(login)
      .pipe(
        finalize(() => this.carregando = false)
      )
      .subscribe(
        (response: any) => {
          this.router.navigate(['/']);
        },
        (error) => {
          if (error.status === 500) {
            this.toaster.show({
              type: 'danger',
              text: 'O servidor pode estar indisponível, consulte um administrador do sistema.',
            });
          } else {
            this.toaster.show({
              type: 'warning',
              text: (error && error.error && error.error.detail) || 'Usuário ou senha incorretos.'
            });
          }
        }
      );
  }
}


